import { useApp } from '@/contexts';

import { PageContainer, PageHeading } from '@/components/layout';

import { AnalyticsOverview } from '../components/AnalyticsOverview';

export const AnalyticsPage = () => {
  const { tenantId } = useApp();

  return (
    <PageContainer>
      <PageHeading title="Analytics" subtitle="View workspace metrics and execution insights" />
      <AnalyticsOverview tenantId={tenantId} />
    </PageContainer>
  );
};
